const appJson = "application/json";

export async function getRequest(url, token) {
    return await sendRequest("GET", url, null, token, false);
}

export async function getUrl(route) {
    const apiUrl = await getRequest("settings/GetAPIConnectionString", null);
    return `${apiUrl}/${route}`;
}

export async function postForm(url, body, token) {
    return await postInternal(url, body, token, false);
}

async function postInternal(url, body, token, content) {
    return await sendRequest("POST", url, body, token, content);
}

export async function postRequest(url, body, token) {
    return await postInternal(url, body, token, true);
}

export async function putRequest(url, body, token) {
    return await sendRequest("PUT", url, body, token, true);
}

async function sendRequest(method, url, body, token, content) {
    var headers = {};
    if (token != null) {
        const tokenHeader = "Bearer " + token

        if (content) {
            headers = {
                "Authorization": tokenHeader,
                "Content-Type": appJson
            };
        }
        else {
            headers = {
                "Authorization": tokenHeader
            };
        }
    }
    else if (content) {
        headers = {
            "Content-Type": appJson
        };
    }

    const request = new Request(url, {
        method: method,
        headers: headers,
        body: body
    });

    const result = await fetch(request
    ).then(response => {
        const contentType = response.headers.get("content-type");

        if (contentType != null) {
            if (contentType.indexOf("text/plain") !== -1) {
                return response.text();
            }

            if (contentType.indexOf(appJson) !== -1 ||
                contentType.indexOf("application/problem+json") !== -1) {
                return response.json();
            }

            if (contentType.indexOf("application/pdf") !== -1) {
                return response.blob();
            }

            if (contentType.indexOf("text/html") !== -1) {
                return null;
            }
        }
        return response.text();
    }).catch(error => {
        console.log(error);
        return error;
    });

    return result;
}

export function setResponse(data, dispatch, type, fetchingType) {
    if (validResponse(data)) {
        dispatch({ type: type, data });
    }

    data = false;
    dispatch({ type: fetchingType, data });
}

export function validResponse(data) {
    var valid = false;

    if (data != null &&
        data !== "" &&
        data.stack == null) {
        if (data.status == null ||
            (data.status != null &&
                data.status >= 200 &&
                data.status < 300)) {
            valid = true;
        }
    }

    return valid;
}



// WEBPACK FOOTER //
// ./src/data/Fetch.js